/** Upscale model ids (dependency-free so mediaModels can import it). */
export const UPSCALE_MODEL_IDS = [
  "flux-video-upscale",
  "byteplus-vod-enhance",
  "seedream-5.0-lite-upscale",
] as const;

export function isUpscaleModelId(id: string | null | undefined): boolean {
  return !!id && (UPSCALE_MODEL_IDS as readonly string[]).includes(id);
}

/** Runway Aleph 2.0 (OpenRouter) video edit / widen job model id. */
export const ALEPH_MODEL_ID = "aleph-2";

/** Video jobs that validate their own limits (upscale.ts, videoWiden.ts), not the Seedance catalog. */
export function isSelfValidatedVideoModelId(id: string | null | undefined): boolean {
  return isUpscaleModelId(id) || id === ALEPH_MODEL_ID;
}
